<div class="admin-page">
  <div class="page-header">
    <h1>{{ 'SIGN_ORDER.ADMIN.TITLE' | translate }}</h1>
  </div>

  <div class="filters-bar">
    <input nz-input
      [placeholder]="'SIGN_ORDER.ADMIN.SEARCH_PLACEHOLDER' | translate"
      [(ngModel)]="search"
      (ngModelChange)="onSearchChange()"
      class="search-input"
    />
    <nz-select
      [ngModel]="statusFilter"
      (ngModelChange)="statusFilter = $event; onFilterChange()"
      [nzPlaceHolder]="'SIGN_ORDER.ADMIN.FILTER_STATUS' | translate"
      nzAllowClear
      class="filter-select"
    >
      <nz-option nzValue="pending_payment" [nzLabel]="'SIGN_ORDER.STATUS.PENDING_PAYMENT' | translate"></nz-option>
      <nz-option nzValue="payment_received" [nzLabel]="'SIGN_ORDER.STATUS.PAYMENT_RECEIVED' | translate"></nz-option>
      <nz-option nzValue="processing" [nzLabel]="'SIGN_ORDER.STATUS.PROCESSING' | translate"></nz-option>
      <nz-option nzValue="ordered_from_supplier" [nzLabel]="'SIGN_ORDER.STATUS.ORDERED_FROM_SUPPLIER' | translate"></nz-option>
      <nz-option nzValue="received_from_supplier" [nzLabel]="'SIGN_ORDER.STATUS.RECEIVED_FROM_SUPPLIER' | translate"></nz-option>
      <nz-option nzValue="shipped" [nzLabel]="'SIGN_ORDER.STATUS.SHIPPED' | translate"></nz-option>
      <nz-option nzValue="completed" [nzLabel]="'SIGN_ORDER.STATUS.COMPLETED' | translate"></nz-option>
      <nz-option nzValue="cancelled" [nzLabel]="'SIGN_ORDER.STATUS.CANCELLED' | translate"></nz-option>
    </nz-select>
    <nz-date-picker
      [ngModel]="dateFrom"
      (ngModelChange)="dateFrom = $event; onFilterChange()"
      [nzPlaceHolder]="'SIGN_ORDER.ADMIN.DATE_FROM' | translate"
      class="date-picker"
    ></nz-date-picker>
    <nz-date-picker
      [ngModel]="dateTo"
      (ngModelChange)="dateTo = $event; onFilterChange()"
      [nzPlaceHolder]="'SIGN_ORDER.ADMIN.DATE_TO' | translate"
      class="date-picker"
    ></nz-date-picker>
  </div>

  <nz-alert *ngIf="errorMessage" nzType="error" [nzMessage]="errorMessage" nzShowIcon></nz-alert>

  <nz-spin [nzSpinning]="isLoading">
    <nz-table [nzData]="orders" [nzShowPagination]="false" nzSize="middle" *ngIf="orders.length; else emptyState">
      <thead>
        <tr>
          <th>{{ 'SIGN_ORDER.ADMIN.ORDER_NUMBER' | translate }}</th>
          <th>{{ 'SIGN_ORDER.ADMIN.DATE' | translate }}</th>
          <th>{{ 'SIGN_ORDER.ADMIN.COMPANY' | translate }}</th>
          <th>{{ 'SIGN_ORDER.ADMIN.REQUESTER' | translate }}</th>
          <th>{{ 'SIGN_ORDER.ADMIN.PRODUCT' | translate }}</th>
          <th>{{ 'SIGN_ORDER.ADMIN.PROPERTIES' | translate }}</th>
          <th>{{ 'SIGN_ORDER.ADMIN.COPIES' | translate }}</th>
          <th>{{ 'SIGN_ORDER.ADMIN.TOTAL' | translate }}</th>
          <th>{{ 'SIGN_ORDER.ADMIN.STATUS' | translate }}</th>
          <th>{{ 'SIGN_ORDER.ADMIN.ACTIONS' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let order of orders">
          <td><code>{{ order.orderNumber }}</code></td>
          <td>{{ formatSignOrderDate(order.createdAt, translate.currentLang) }}</td>
          <td>{{ order.company?.name }}</td>
          <td>{{ order.requester?.displayName }}</td>
          <td>{{ localizedText(order.product?.name) }}</td>
          <td>{{ order.uniquePropertyCount }}</td>
          <td>{{ order.totalCopies }}</td>
          <td>{{ formatCents(order.grossTotalCents, order.currency) }}</td>
          <td>
            <nz-tag [nzColor]="getStatusColor(order.status)">{{ getStatusLabel(order.status) }}</nz-tag>
          </td>
          <td>
            <a [routerLink]="['/admin/sign-orders', order.publicId]">
              {{ 'SIGN_ORDER.ADMIN.VIEW_DETAIL' | translate }}
            </a>
          </td>
        </tr>
      </tbody>
    </nz-table>

    <ng-template #emptyState>
      <div class="empty-state">
        <p>{{ 'SIGN_ORDER.ADMIN.NO_ORDERS' | translate }}</p>
      </div>
    </ng-template>

    <nz-pagination
      *ngIf="total > pageSize"
      [(nzPageIndex)]="page"
      [nzPageSize]="pageSize"
      [nzTotal]="total"
      (nzPageIndexChange)="loadOrders($event)"
      nzSize="small"
      class="pagination"
    ></nz-pagination>
  </nz-spin>
</div>
